import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TokenService } from '../../../../../core/services/token.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { ToastNotifService } from '../../../../../core/services/toastNotif.service';
import { Router } from '@angular/router';
import { LanguageService } from '../../../../../core/services/language.service';
import { Subscription } from 'rxjs';
import {
  ChargerStatusResponse,
  CreateTransactionResponse,
  PricingResponse,
  ChargerPayload,
  TransactionPayload,
  EVChargerResponse,
  ParkingTransactionEVDto,
  CityparkingInvoiceEvCount,
  ActionApiEvResponse,
  ScanQREntriesPayload,
} from '../../../../../core/models/ev.model';
import { PssLoadingComponent } from '../../../../../tools/template/pss/pss-loading/pss-loading.component';
import { HomeTopUpModel } from '../../../../../core/models/user.model';
import { ToastWarnComponent } from '../../../../../tools/template/toast/toast-warn/toast-warn.component';
import { ToastFailedComponent } from '../../../../../tools/template/toast/toast-failed/toast-failed.component';
import { ToastSuccessComponent } from '../../../../../tools/template/toast/toast-success/toast-success.component';
import { ToastCustomService } from '../../../../../tools/services/toast/toast-custom/toastCustom.service';
import { ModalEvChargerScanQrComponent } from '../../../modals/services-category/ev-charger/modal-ev-charger-scan-qr/modal-ev-charger-scan-qr.component';
import { ApiTopUpService } from '../../../../../core/services/api/Topup/api-topup';
import { ApiPaymentService } from '../../../../../core/services/api/Payment/api-payment';
import { ApiEvChargerService } from '../../../../../core/services/api/Ev-chager/api-Ev-Carger';
import { ApiPaymentTransactionService } from '../../../../../core/services/api/Payment/api-payment-transaction';

@Component({
  selector: 'app-ev-charger',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    PssLoadingComponent,
    ModalEvChargerScanQrComponent,
  ],
  templateUrl: './ev-charger.component.html',
  styleUrl: './ev-charger.component.css',
})
export class EvChargerComponent implements OnInit {
  // Systems
  private intervalId: any;
  private intervalIdAutoEvDetail: any;

  license: string = '';
  token: string = '';
  uid: string = '';
  site: string = 'PSS_T00102';
  isSaveLoading: boolean = false;
  currentLang: 'TH' | 'EN' = 'TH';
  chargerDetails: ChargerStatusResponse | null = null;
  charger: ChargerPayload | null = null;
  transaction_id: string = '';
  transaction: TransactionPayload | null = null;
  isLoading: boolean = false;

  statusFilter: string = 'all';

  searchLicense: string = '';
  filterParkingTransactionEVDto: ParkingTransactionEVDto[] | null = null;
  parkingTransactionEVDto: ParkingTransactionEVDto[] = [];
  topUpData: HomeTopUpModel = {
    vehicleCount: 0,
    evCount: 0,
    amount: 0,
    activateCard: 0,
    notify: 0,
  };
  sub!: Subscription;

  // Scan QR
  isShowScanQrModal: boolean = false;
  saveEvEntriesByQRCode: ScanQREntriesPayload | null = null;

  // Ev charger Invoice
  countCityParkingInvoice: CityparkingInvoiceEvCount = { count: 0 };

  // Alert
  isSuccess: boolean = false;
  textSuccess: string = '';
  detailSuccess: string = '';
  isWarning: boolean = false;
  textWarn: string = '';
  detailWarn: string = '';
  isError: boolean = false;
  textError: string = '';
  detailError: string = '';

  constructor(
    private router: Router,
    private tokenService: TokenService,
    private apiTopUpService: ApiTopUpService,
    private apiPaymentService: ApiPaymentService,
    private apiPaymentTransactionService: ApiPaymentTransactionService,
    private apiEvChargerService: ApiEvChargerService,
    private cookie: CookieService,
    private toast: ToastNotifService,
    private toastCustomService: ToastCustomService,
    private languageService: LanguageService,
  ) {
    this.sub = this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });
  }

  async ngOnInit(): Promise<void> {
    this.uid =
      this.cookie.get('line_uid') || localStorage.getItem('line_uid') || '';
    // JWT is HttpOnly cookie — token_user no longer used
    this.token = '';

    setTimeout(() => {
      this.getParkingEVUser();
      // ใน ngOnInit() ของ ev-charger.component.ts
      // this.parkingTransactionEVDto = [
      //   { historyUuid: '1', licensePlate: 'กข 1234', status: 'charging' } as any,
      //   { historyUuid: '2', licensePlate: 'มข 5678', status: 'parked' } as any,
      //   { historyUuid: '3', licensePlate: 'ฮฮ 9999', status: 'charging' } as any,
      //   { historyUuid: '4', licensePlate: 'ชช 8888', status: 'parked' } as any,
      // ];

      this.getHomeTopUp();
    }, 200);

    // Ev charger Invoice
    this.getCountCityParkingInvoice();
  }

  onIntervalEV() {
    this.intervalId = setInterval(() => {
      this.getParkingEVUser();
    }, 7000); // 7 sec
  }
  onIntervalAutoEvDetail() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    this.intervalId = setInterval(() => {
      this.getParkingEVUserAuto();
    }, 7000); // 7 sec
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  /* ---------------------------------- Functions ---------------------------------- */
  /* --- Style --- */
  showWarning(text: string, detail: string = '') {
    // this.toast.warning(text);
    this.toastCustomService.showWarning('', text);
  }
  showError(text: string, detail: string = '') {
    // this.toast.Error(text);
    this.toastCustomService.showError('', text);
  }
  showSuccess(text: string, detail: string = '') {
    // this.toast.success(text);
    this.toastCustomService.showSuccess('', text);
  }
  /* --- Function --- */
  goback() {
    this.router.navigate(['/home']);
  }
  goToNavigate(historyUuid: string) {
    this.router.navigate(['ev-charger-detail', historyUuid]);
  }
  goToNavigateTopup() {
    this.router.navigate(['top-up-ev-charger']);
  }
  goToNavigateHistory() {
    this.router.navigate(['ev-charger-history']);
  }
  goToNavigateInvoice() {
    this.router.navigate(['ev-charger-invoice']);
  }
  hour(totalTime: number) {
    return Math.floor(totalTime / 60);
  }

  toggleFilterEvCharger(status: string) {
    this.statusFilter = status;
    if (status === 'all') {
      this.filterParkingTransactionEVDto = null;
      return;
    }
    this.filterParkingTransactionEVDto = this.parkingTransactionEVDto.filter(
      (p) => p.status === (status === 'parked' ? 0 : 1),
    );
    console.log(
      'Parking status : ',
      this.filterParkingTransactionEVDto,
      status,
    );
  }
  /* ----- Search ----- */
  onSearchCharger() {
    if (this.searchLicense !== '') {
      this.filterParkingTransactionEVDto = this.parkingTransactionEVDto.filter(
        (p) =>
          p.licensePlate
            .toLowerCase()
            .includes(this.searchLicense.toLowerCase()),
      );
    } else {
      // ถ้า search ว่าง ให้รีเซ็ต filter ตามหมวดหมู่ที่เลือกปัจจุบัน
      const filterStatus = this.parkingTransactionEVDto?.filter(
        (p) =>
          p.status ===
          (this.statusFilter === 'parked'
            ? 0
            : this.statusFilter === 'charging'
              ? 1
              : true),
      );
      this.filterParkingTransactionEVDto =
        filterStatus && filterStatus.length > 0 ? filterStatus : null;
    }
    console.log(
      'Search license : ',
      this.searchLicense,
      this.filterParkingTransactionEVDto,
    );
  }

  onSearchClear() {
    this.searchLicense = '';
    this.filterParkingTransactionEVDto = null;
  }

  onClickReload() {
    this.getParkingEVUser();
    this.getHomeTopUp();
  }
  /* ---------------- Scan QR Logic ---------------- */

  openScanQrModal() {
    this.isShowScanQrModal = true;
  }

  closeScanQrModal() {
    this.isShowScanQrModal = false;
  }
  handleScanResult(
    response: ActionApiEvResponse,
    evEntriesByQRCode: ScanQREntriesPayload,
  ) {
    console.log('✅Save Modal Result :', response, evEntriesByQRCode);
    this.showSuccess(
      this.currentLang === 'TH' ? response.message : response.message_en,
    );
    this.isLoading = true;
    // เก็บข้อมูลที่สแกนได้
    this.saveEvEntriesByQRCode = evEntriesByQRCode;
    // หน่วงเวลา 3 วินาที เพื่อให้ข้อมูลถูกบันทึก
    setTimeout(() => {
      clearInterval(this.intervalId);
      this.getParkingEVUserAuto();
    }, 3000);
  }
  /* ------------------------------------------ API ------------------------------------------- */
  createTransaction(payload: ChargerPayload) {
    console.log('payload', payload);
    if (payload) {
      this.apiPaymentTransactionService
        .createTransaction(this.token, this.site, payload.entrance_uuid)
        .subscribe({
          next: (res: CreateTransactionResponse) => {
            console.log('📦 Response:', res);
            if (res) {
              this.transaction = res.payload;
            } else {
              console.log('error no data');
            }
          },
          error: (err) => {
            console.error('❌ error in createTransaction:', err);
            this.showError(
              this.currentLang === 'TH'
                ? 'ค้นหาข้อมูลไม่พบ'
                : 'Information not found.',
            );
            this.isSaveLoading = false;
          },
          complete: () => {
            this.isSaveLoading = false;
          },
        });
    } else {
      console.log('No payload');
    }
  }

  getParkingEVUser() {
    // clearInterval(this.intervalId);
    this.filterParkingTransactionEVDto = null;
    if (this.uid) {
      //this.isLoading = true;
      this.apiEvChargerService
        .getParkingEVUser(this.uid, this.token)
        .subscribe({
          next: (response: ParkingTransactionEVDto[]) => {
            // เคลียร์ interval เมือ่เจอข้อมูลที่มีสถานะจอดอยู่ (status = 0)
            clearInterval(this.intervalId);
            console.log('response getParkingEVUse : ', response);
            // สำหรับวนลูป Interval ดึงข้อมูล
            if (response.length === 0) {
              this.isLoading = false;
              this.parkingTransactionEVDto = [];
              this.onIntervalEV();
              return;
            }

            //this.isLoading = false;
            const sortStatus = response.sort((a, b) => {
              return b.status - a.status;
            });
            this.parkingTransactionEVDto = sortStatus;
            // เคลียร์ interval เมือ่เจอข้อมูลที่มีสถานะจอดอยู่ (status = 0)
            clearInterval(this.intervalId);
          },
          error: (err) => {
            this.isLoading = false;
            console.error('โหลดบัตรสมาชิกล้มเหลว', err);
            this.showError(
              this.currentLang === 'TH'
                ? 'โหลดข้อมูลล้มเหลว'
                : 'Failed to load data.',
            );
          },
          complete: () => {
            this.isLoading = false;
          },
        });
    } else {
      this.showError(
        this.currentLang === 'TH'
          ? 'ไม่พบ LINE uid กรุณาเข้าใหม่ผ่าน /register'
          : 'Missing LINE uid. Please re-enter via /register.',
      );
    }
  }
  getParkingEVUserAuto() {
    // clearInterval(this.intervalId);
    this.filterParkingTransactionEVDto = null;
    if (this.uid) {
      //this.isLoading = true;
      this.apiEvChargerService
        .getParkingEVUser(this.uid, this.token)
        .subscribe({
          next: (response: ParkingTransactionEVDto[]) => {
            // เคลียร์ interval เมือ่เจอข้อมูลที่มีสถานะจอดอยู่ (status = 0)
            clearInterval(this.intervalId);
            console.log('response getParkingEVUserAuto : ', response);
            // เลือกข้อมูลสำหรับส่งข้อมูลไปหน้า detail
            const selectedParkingEv = response.find(
              (item) =>
                item.vehicleId === this.saveEvEntriesByQRCode?.vehicleId,
            );
            const sortStatus = response.sort((a, b) => {
              return b.status - a.status;
            });
            this.parkingTransactionEVDto = sortStatus;

            // สำหรับวนลูป Interval ดึงข้อมูล
            console.log('Select Ev EntryDetail : ', selectedParkingEv);
            if (!selectedParkingEv) {
              this.isLoading = false;
              this.onIntervalAutoEvDetail();
              return;
            }

            // ส่งไปหน้า detail
            this.goToNavigate(selectedParkingEv.historyUuid);
          },
          error: (err) => {
            this.isLoading = false;
            console.error('โหลดบัตรสมาชิกล้มเหลว', err);
            this.showError(
              this.currentLang === 'TH'
                ? 'โหลดข้อมูลล้มเหลว'
                : 'Failed to load data.',
            );
          },
          complete: () => {
            this.isLoading = false;
          },
        });
    } else {
      this.showError(
        this.currentLang === 'TH'
          ? 'ไม่พบ LINE uid กรุณาเข้าใหม่ผ่าน /register'
          : 'Missing LINE uid. Please re-enter via /register.',
      );
    }
  }

  // Ev invoice
  getCountCityParkingInvoice() {
    this.isLoading = true;
    this.apiPaymentService
      .getCountCityParkingInvoice(this.uid, this.token)
      .subscribe({
        next: (res: CityparkingInvoiceEvCount) => {
          console.log('📨 Response EV charger Invoice count :', res);
          this.isLoading = false;
          this.countCityParkingInvoice = res;
        },
        error: (err) => {
          this.isLoading = false;
          // this.showError(err.message);
        },
      });
  }
  // Topup
  getHomeTopUp() {
    this.isLoading = true;
    if (this.uid) {
      this.apiTopUpService.getHomeTopUp(this.uid, this.token).subscribe({
        next: (response: HomeTopUpModel) => {
          console.log('response data Home Top Up : ', response);
          this.isLoading = false;
          this.topUpData = response;

          sessionStorage.setItem('homeTopUp', JSON.stringify(response));
        },
        error: (err) => {
          console.error('โหลดข้อมูล Home Top Up ล้มเหลว', err);
          this.isLoading = false;
        },
      });
    } else {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'ไม่พบ LINE uid กรุณาเข้าใหม่ผ่าน /register'
          : 'Missing LINE uid. Please re-enter via /register.',
      );
      return;
    }
  }
}
